export default __webpack_public_path__ + "assets/bff872dcebf3325e0e0aca4359c7618f.png";